import * as DataUtils from './DataUtils.js';

export const PreFiltro = {
  TODOS: 'todos',
  CLUB_RIVAL: 'club_rival',
  SELECCION_RIVAL: 'seleccion_rival',
};

export const GetEquipos = async (prefiltro, objetoFiltro, pais, tipoEquipo, nombre, categoria) => {
  let url;
  switch (prefiltro) {
    case PreFiltro.CLUB_RIVAL: {
      url = 'clubes/' + objetoFiltro.id + '/rivales/equipos';
      break;
    }
    case PreFiltro.SELECCION_RIVAL: {
      url = 'selecciones/' + objetoFiltro.id + '/rivales/equipos';
      break;
    }
    case PreFiltro.TODOS:
    default: {
      url = 'equipos';
      break;
    }
  }
  let separador = '?';
  if (pais) {
    url += separador + 'pais=' + pais.id;
    separador = '&';
  }
  if (tipoEquipo && tipoEquipo.codigo) {
    url += separador + 'tipo=' + tipoEquipo.codigo;
    separador = '&';
  }
  if (categoria && categoria.codigo) {
    url += separador + 'categoria=' + categoria.codigo;
    separador = '&';
  }
  if (nombre) {
    url += separador + 'nombreParcial=' + nombre;
  }
  return DataUtils.FetchLista(url);
};
